const $ = jQuery;

$(document).ready(function () {
    // Check if the popup has already been displayed using sessionStorage
    let popupDisplayed = sessionStorage.getItem('popupDisplayed') === 'true';
    const btnDisabled = $('.btn-disabled').length > 0;

    $('.center').fadeOut(); // Initialize preloader if used
    $('body').css('overflow', 'auto'); // Ensure initial overflow state

    function displayPopup() {
        if (!btnDisabled && !popupDisplayed) {
            $('.custom-package-popup').fadeIn(500, function() {
                $('body').css('overflow', 'hidden');
            });
            popupDisplayed = true;
            sessionStorage.setItem('popupDisplayed', 'true'); // Save the state in sessionStorage
        }
    }

    function hidePopup() {
        $('.custom-package-popup').fadeOut(500, function() {
            $('body').css('overflow', 'auto');
        });
    }

    $(document).on('mouseleave', function (e) {
        if (!popupDisplayed && e.clientY < 10) {
            displayPopup();
        }
    });

    $('.custom-package-close, .custom-package-stay-button').click(function () {
        hidePopup();
    });

    function modal_interaction() {
        $('.modal-trigger').on('click', function () {
            $(this).siblings('.modal').addClass('opened');
            $('body').css('overflow', 'hidden');
        });

        $('.close-trigger').on('click', function () {
            $(this).closest('.modal').removeClass('opened');
            if (!$('.modal.opened').length) {
                $('body').css('overflow', 'auto');
            }
        });

        $('.modal-overlay').on('click', function () {
            $(this).parent().removeClass('opened');
            if (!$('.modal.opened').length) {
                $('body').css('overflow', 'auto');
            }
        });

        $(document).on('keydown', function (e) {
            if (e.keyCode === 27) {
                $('.close-trigger').trigger('click');
            }
        });
    }

    modal_interaction();

    function setupCurrencySwitcher() {
        $('#selectedPackage a').click(function (e) {
            e.preventDefault();
            const url = $(this).attr('href');
            window.location.href = url;
        });
    }

    setupCurrencySwitcher();

    $('#menuOpenBtn').click(function () {
        $('.header-mobileMenu').toggleClass('opened');
    });

    $('.header-menu > .menu-item-has-children').click(function () {
        $(this).toggleClass('active').find('.sub-menu').first().stop().slideToggle();
    });

    $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function (event) {
        const target = $(this.hash);
        if (target.length) {
            event.preventDefault();
            $('html, body').animate({
                scrollTop: target.offset().top
            }, 1000);
        }
    });

    $('.reviews-wrapper').slick({
        dots: false,
        slidesToShow: 3.3,
        slidesToScroll: 1,
        arrows: true,
        adaptiveHeight: true,
        autoplay: true,
        autoplaySpeed: 4000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: true
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true
                }
            }
        ]
    });

    const topButton = $('#top');
    $(window).scroll(function () {
        if ($(this).scrollTop() > 300) {
            topButton.addClass('show');
        } else {
            topButton.removeClass('show');
        }
    });

    topButton.click(function (e) {
        e.preventDefault();
        $('html, body').animate({ scrollTop: 0 }, '300');
    });

    function video_play() {
        $('#video-play').click(function () {
            const video = $(this).siblings('video').get(0); // Получаем DOM-элемент видео
            if (video) {
                video.play();
                $(this).fadeOut(); // Скрываем кнопку воспроизведения после начала проигрывания
            } else {
                console.error('Video element not found!');
            }
        });
    }

    video_play();

});
